import { render, staticRenderFns } from "./profitlist.vue?vue&type=template&id=cf49d052&scoped=true"
import script from "./profitlist.vue?vue&type=script&lang=js"
export * from "./profitlist.vue?vue&type=script&lang=js"
import style0 from "./profitlist.vue?vue&type=style&index=0&id=cf49d052&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf49d052",
  null
  
)

export default component.exports